import React, { useState, useEffect}  from 'react';
import {BannerType} from '../interfaces';
import axios from 'axios';
import {API_TOKEN, API_URL} from '../../constants';

const Banner = (props: { banners: BannerType[] }) => {

    const {banners}  = props;


    const [counted, setCounted] = useState(false);
    const [currentIdx, setCurrentIdx] = useState(0);
    let interval: NodeJS.Timeout;


    let currentUrl = '';
    let bannersUrl = '';
    if (banners[currentIdx]) {
        currentUrl = `${API_URL}/banner/${banners[currentIdx].internalurl}/?do=image`;
        bannersUrl = `${API_URL}/api/?do=getbanner&id=${banners[currentIdx].id}&token=${API_TOKEN}&lang=nat&format=json`;
    }




    useEffect(() => {
        if (!counted && bannersUrl.startsWith('http')) {
            axios.get(bannersUrl).then(result => {
                if (result) {
                    setCounted(true);
                }
            })
        }
        interval = setInterval(() => {
            let idx = currentIdx + 1;
            if (idx >= banners.length) {
                setCurrentIdx(0);
            } else {
                setCurrentIdx(idx);
            }

        }, 5000);
        return function cleanup() {
            clearInterval(interval);
        };
    });

    const bannerClick = () => {
        const bannerClickUrl = `${API_URL}/api/?do=bannerclick&id=${banners[currentIdx].id}&token=${API_TOKEN}&lang=nat&format=json`;
        axios.get(bannerClickUrl).then(res => {});
        window.open(banners[currentIdx].target_url, '_blank');
    }

    const tm = setTimeout(() => {
        if (banners[currentIdx]) {
            currentUrl = `${API_URL}/banner/${banners[currentIdx].internalurl}/?do=image`;
        }
        clearTimeout(tm);
    }, 0)

    return currentUrl.startsWith('http') ? <div className='banner-front full-width'>
             <img src={currentUrl} alt="banner" onClick={bannerClick}/>
        </div> : null

}

export default Banner;
